import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import './Popup.scss';
import './Leaflet.scss';

const Popup = ({ children, currentCoords, closeMap, role }) => (
  <div
    aria-hidden="true"
    className="popup"
    onClick={closeMap}
    onKeyDown={closeMap}
  >
    <div className="popup-overlay" />
    <div className="popup-map">
      <p className="popup-location-for">{children}</p>

      <MapContainer center={currentCoords} zoom={10} scrollWheelZoom>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={currentCoords} />
      </MapContainer>
    </div>
  </div>
);

export default Popup;
